import { cn } from '../../lib/utils.ts';

export const Skeleton = ({ className }: { className?: string }) => (
  <div
    aria-hidden="true"
    className={cn(
      'rounded-xl bg-[linear-gradient(90deg,var(--fill)_25%,var(--line)_37%,var(--fill)_63%)] bg-[length:400%_100%] animate-[shimmer_1.4s_ease_infinite]',
      className,
    )}
  />
);
